import { toast } from "../../utils/toast";
import { CREATE as CREATE_AVOCADO } from "../Avocados/actionsTypes";
import {
    CREATE, DELETE, GET,
    UPDATE
} from "./actionsTypes";

import { formatFruit2Frontend } from "../Avocados/utils";
import { defaultCheck } from "./constants";
import { populate_dummy_images } from "./dummy_images";
import { formatCheck2Frontend } from "./util";

const checks = {
    isLoading: false,
    isUpdating: false,
    current: defaultCheck,
};
export default (state = checks, action) => {
    let current;
    switch (action.type) {
    case GET.LOADING:
        return { ...state, isLoading: true };

    case CREATE.LOADING:
        // toast.info('Saving check...', {
        //     toastId: 'create-check',
        //     autoClose: 1000,
        // });
        return { ...state, isUpdating: true };

    case UPDATE.LOADING:
        return { ...state, isUpdating: false };

    case DELETE.LOADING:
        toast.info("Deleting check...", {
            toastId: "delete-checks",
            autoClose: 1500,
        });
        return {
            ...state,
            isUpdating: true
        };

    case GET.ERROR:
    case CREATE.ERROR:
    case UPDATE.ERROR:
    case DELETE.ERROR:
        return { ...state, isLoading: false, isUpdating: false };

    case GET.SUCCESS:
        return { ...state, isLoading: false, current: filter_check(action.payload.data) };

    case CREATE.SUCCESS:
        // toast.update('create-check', { render: "Check started", type: toast.TYPE.SUCCESS, autoClose:1000 });
        // Guard against null response (e.g., from /complete endpoint which returns 200 with no body)
        if (!action.payload.data) {
            return { ...state, isUpdating: false };
        }
        return {
            ...state, isLoading: false, isUpdating: false, current: formatCheck2Frontend({ ...action.payload.data, avocados: [] }),
        };

    case CREATE_AVOCADO.SUCCESS:
        current = filter_check({ ...state.current, avocados: [...state.current.avocados, action.payload.data] });
        return { ...state, isLoading: false, current };

    case UPDATE.SUCCESS:
        toast.update(`update-check-${action.payload.data.check_id}`, { render: "Check updated!", type: "success", autoClose: 3500 });
        return { ...state, isUpdating: false, current: filter_check(action.payload.data) };

    case DELETE.SUCCESS:
        toast.update("delete-checks", { render: "Check deleted!", type: "info", autoClose: 3500 });
        return {
            ...state, isLoading: false, isUpdating: false, current: action.payload.data,
        };

    default:
        return state;
    }
};

const filter_check = (check) => formatCheck2Frontend({
    ...check,
    avocados: check.avocados.filter((i) => i.is_invalid === false).map((i) => populate_dummy_images(formatFruit2Frontend(i)))
});
